import http from '@/http/index.js'
import OSS from 'ali-oss'
import { Message as ElMessage } from 'element-ui'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Agora from './agora'
import Chat from './chat'
import Emedia from './emedia'
import FriendModule from './friendModule'
import Group from './group'
import Login from './login'
import Presence from './presence'
import Resetpassword from './resetpassword'
Vue.use(Vuex)
export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  modules: {
    login: Login,
    chat: Chat,
    friendModule: FriendModule,
    group: Group,
    emedia: Emedia,
    agora: Agora,
    presence: Presence,
    resetpassword: Resetpassword
  },
  state: {
    unReadAskOrder: 0,
    chatShow: false,
    homePath: {},
    menuList: [],
    menuTree: [],
    menuLeftTree: [],
    ossClient: null,
    stsToken: {},
    areaTree: [],
    chatPageData: {},
    user: {},
    refreshPage: false,
    lastBreadCrumb: {},
    sidebar: true,
  },
  mutations: {
    SET_UNREAD_ASK_ORDER (state, b) {
      state.unReadAskOrder = b
    },
    SET_CHAT_PAGE_DATA (state, b) {
      state.chatPageData = b
    },
    SET_CHAT_SHOW (state, val) {
      state.chatShow = val
    },
    SET_HOME_PATH (state, val) {
      state.homePath = val
    },
    SET_MENU_LIST (state, val) {
      state.menuList = val
    },
    SET_MENU_LEFT_TREE (state, val) {
      state.menuLeftTree = val
    },
    SET_MENU_TREE (state, val) {
      state.menuTree = val
    },
    SET_OSS_CLIENT (state, val) {
      state.ossClient = val
    },
    SET_STS_TOKEN (state, val) {
      state.stsToken = val
    },
    SET_AREA_TREE (state, val) {
      state.areaTree = val
    },
    SET_REFRESH_PAGE (state, val) {
      state.refreshPage = val
    },
    SET_LAST_BREAD_CRUMB (state, val) {
      state.lastBreadCrumb = val
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar = !state.sidebar
    },
    SET_USER (state, val) {
      state.user = val
    }
  },
  actions: {
    updateChatStatus ({ dispatch, state }, userId) {
      return new Promise((resolve) => {
        if (!((state.chatPageData.currentConsultingType == 1 && state.chatPageData.tuwenConsultationStatus == 1) || (state.chatPageData.currentConsultingType == 2 && state.chatPageData.phoneConsultationStatus == 1))) {
          http.post('/consult/doctorSendMessage', {
            doctorId: state.chatPageData.tbDoctorId,
            tbUserId: userId
          })
        }
        if (state.chatPageData.tuwenConsultationStatus === 1 && state.chatPageData.currentConsultingType === 1 && state.chatPageData.tbAskIsAnswer === 1) {
          http.post('/consult/updateConsultationOrder', {
            tbId: state.chatPageData.tbTuwenConsultingOrderId,
            tbUserType: 2,
            updateType: 1,
            tbState: 0
          }).then(res => {
            if (res.code === 1000) {
              setTimeout(() => {
                dispatch('setChatPageData')
              }, 2000)
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    },
    setChatPageData: ({ commit, state }, userUuid = '') => {
      return new Promise((resolve) => {
        const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'));
        console.log(state.chat.currentConversationId)
        if (userInfo.userId && state.chat.currentConversationId) {
          if (userUuid === '' || userUuid === state.chat.currentConversationId) {
            http.post('/consult/getChatPageData', {
              tbUserUuid: state.chat.currentConversationId,
              tbUuid: userInfo.userId
            }).then(res => {
              if (res.code === 1000) {
                commit('SET_CHAT_PAGE_DATA', res.data)
                resolve(res.data)
              }
            })
          }
        }
      })
    },
    getMenuListByUser ({ commit, state }) {
      return new Promise((resolve, reject) => {
        http.post('/menu/getMenuListByUser', {})
          .then((res) => {
            if (res.code === 1000) {
              res.data.leftTree = res.data.leftTree.sort((a, b) => a.tbSort - b.tbSort)
              commit('SET_HOME_PATH', res.data.leftTree[0].children[0])
              commit('SET_MENU_LIST', res.data.list)
              commit('SET_MENU_TREE', res.data.tree)
              commit('SET_MENU_LEFT_TREE', res.data.leftTree)
              resolve(res.data)
            } else if (res.code === 401) {
              router.push('/login')
              reject('error')
              return false
            } else {
              ElMessage({
                message: '错误信息：' + res.message,
                type: 'error',
                duration: 3 * 1000
              })
              resolve('error')
              return false
            }
          })
          .catch((error) => {
            resolve(error)
          })
      })
    },
    setOssClient ({ commit, state, dispatch }, vue) {
      return new Promise((resolve, reject) => {
        const ossClient = new OSS({
          region: 'oss-cn-beijing',
          bucket: 'hyl-ymm',
          accessKeyId: state.stsToken.accessKeyId,
          accessKeySecret: state.stsToken.accessKeySecret,
          stsToken: state.stsToken.securityToken,
          refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            const stsToken = await dispatch('setStsToken')
            return {
              accessKeyId: stsToken.accessKeyId,
              accessKeySecret: stsToken.accessKeySecret,
              stsToken: stsToken.securityToken
            }
          },
          refreshSTSTokenInterval: 3500000,
          secure: true
        })
        commit('SET_OSS_CLIENT', ossClient)
        resolve(ossClient)
      })
    },
    setStsToken ({ commit, state }, vue) {
      return new Promise((resolve, reject) => {
        const expiration = state.stsToken?.expiration
        if (expiration && new Date(expiration).getTime() - new Date().getTime() >= 60 * 10 * 1000) {
          resolve(state.stsToken)
        } else {
          http.post(`/getStsToken`, {})
            .then(res => {
              if (res.code === 1000) {
                commit('SET_STS_TOKEN', res.data)
                resolve(res.data)
              } else {
                reject(res)
              }
            })
            .catch(error => {
              reject(error)
            })
        }
      })
    },
    setRefreshPage ({ commit }, val) {
      commit('SET_REFRESH_PAGE', val)
    },
    setLastBreadCrumb ({ commit }, val) {
      window.sessionStorage.setItem('lastBreadCrumb', JSON.stringify(val))
      commit('SET_LAST_BREAD_CRUMB', val)
    },
    toggleSideBars ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    getAreaTree ({ commit }, vue) {
      return new Promise((resolve, reject) => {
        http.post('/area/getTree', {})
          .then(res => {
            if (res.code === 1000) {
              let list = [{
                areaCode: '全选',
                areaName: '全选',
                areaParentId: '0',
                leaf: false,
                id: 100000,
                children: res.data
              }]
              list = vue.setTreeData(list, 'children')
              commit('SET_AREA_TREE', list)
              resolve(list)
            } else {
              reject(res)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getUserInfo ({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        http.post('/users/getLoginedUserInfo', {})
          .then(res => {
            commit('SET_USER', res.data)
            resolve(res.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    unReadAskOrder: state => state.unReadAskOrder,
    chatPageData: state => state.chatPageData,
    chatShow: state => state.chatShow,
    homePath: state => state.homePath,
    menuLeftTree: state => state.menuLeftTree,
    menuTree: state => state.menuTree,
    ossClient: state => state.ossClient,
    stsToken: state => state.stsToken,
    areaTree: state => state.areaTree,
    refreshPage: state => state.refreshPage,
    sidebar: state => state.sidebar,
    lastBreadCrumb: state => {
      if (Reflect.ownKeys(state.lastBreadCrumb).length < 2) {
        return JSON.parse(window.sessionStorage.getItem('lastBreadCrumb')) || {}
      } else {
        return state.lastBreadCrumb
      }
    }
  }
})
